<div class="modal-title text-center m-2">
    <h3> {{ progressTitle }} </h3>
</div>
<div class="modal-body">
    <div class="progress">
        <div class="progress-bar" [ngStyle]="{ 'width': percentage() + '%' }">{{ percentage() }}%</div>
    </div>
    <div class="text-center m-2">
        <p>{{ progressText() }}</p>
        <p>{{ progress() }} of {{ totalTasks() }} </p>
    </div>
</div>
